export const embedSetupDrawerOptions = {
  showHeaderActions: false,
}
